const translations = {
	page_title: "Invitations investisseurs",
	title: "Votre client remplit lui-même son dossier",
	description:
		"Invitez un client à compléter sa souscription sur le portail investisseur. Une fois envoyé, son dossier arrive dans vos brouillons : vous le vérifiez, le complétez, puis le soumettez comme une souscription habituelle.",
	invite: "Inviter un client",
	load_error: "Nous ne parvenons pas à charger vos invitations pour le moment.",
	retry: "Réessayer",
	action_error: "L'opération n'a pas abouti. Réessayez dans un instant.",
	table: {
		search_placeholder: "Chercher une invitation",
		all_statuses: "Tous les statuts",
		client: "Client",
		product: "Produit",
		status: "Statut",
		sent_at: "Lien envoyé le",
		last_activity: "Dernière activité",
		shares: "{{count}} parts",
		one_share: "1 part",
		expired: "Lien expiré",
		valid_until: "Valable jusqu'au {{date}}",
		expired_on: "Expiré le {{date}}",
		reference: "Réf. {{reference}}",
		archived: "Brouillon archivé",
		// Avancement du dossier une fois soumis par le conseiller : l'invitation, elle, reste « Dossier envoyé ».
		dossier_steps: {
			processing: "En cours de traitement",
			waiting_signature: "En cours de signature",
			waiting_transfer_sg: "Signé",
			waiting_validation: "En attente de validation",
			validated: "Validé",
		},
		dossier_details: {
			waiting_transfer_sg: "À transmettre à la société de gestion",
			waiting_validation: "Transmis à la société de gestion",
		},
	},
	actions: {
		label: "Actions",
		copy_link: "Copier le lien",
		resend: "Renvoyer",
		revoke: "Révoquer",
		open_dossier: "Voir le dossier",
		link_copied: "Lien copié dans le presse-papiers.",
		link_unavailable: "Le lien n'a pas pu être récupéré. Réessayez dans un instant.",
		copy_failed: "La copie automatique a échoué : sélectionnez le lien pour le copier.",
		revoked: "L'invitation est révoquée.",
	},
	invite_modal: {
		title: "Inviter un client",
		description: "Votre client reçoit un lien personnel pour remplir son dossier. Vous retrouvez ensuite ce dossier dans vos brouillons.",
		person_type: "Votre client souscrit en tant que",
		first_name: "Prénom *",
		last_name: "Nom *",
		contact_caption: "Personne qui remplira le dossier pour la société, en général son représentant légal.",
		company_name: "Raison sociale",
		company_name_caption: "Facultatif. Votre client la confirmera dans son dossier.",
		email: "E-mail *",
		email_caption: "Le lien d'invitation est envoyé à cette adresse.",
		mobile: "Téléphone mobile",
		mobile_caption: "Facultatif. Il sert à envoyer un code de vérification par SMS lorsque le portail le demande.",
		product: "Produit *",
		loading_products: "Chargement des produits…",
		no_product: "Aucun produit proposé par votre cabinet n'est ouvert au portail investisseur pour le moment.",
		submit: "Envoyer l'invitation",
	},
	link_modal: {
		created_title: "Invitation créée",
		resent_title: "Nouveau lien créé",
		copy_title: "Lien de votre client",
		email_sent: "Un e-mail contenant ce lien part vers {{email}}.",
		email_not_sent: "L'e-mail n'est pas parti\u00a0: transmettez vous-même ce lien à votre client.",
		link_label: "Lien personnel de votre client",
		shown_once:
			"Ce lien ne s'affiche qu'une fois et reste valable jusqu'au {{date}}. Pour en obtenir un nouveau, utilisez «\u00a0Renvoyer\u00a0»\u00a0: l'ancien lien cessera alors de fonctionner.",
		kept: "Ce lien reste valable jusqu'au {{date}}. Vous pouvez le recopier à tout moment avec «\u00a0Copier le lien\u00a0». «\u00a0Renvoyer\u00a0» en crée un nouveau\u00a0: l'ancien cesse alors de fonctionner.",
		kept_submitted:
			"Le dossier est envoyé\u00a0: ce lien permet à votre client de suivre son avancement. Il ne périme pas et vous pouvez le recopier à tout moment avec «\u00a0Copier le lien\u00a0».",
		copy: "Copier le lien",
	},
	resend_modal: {
		title: "Renvoyer l'invitation ?",
		text: "Un nouveau lien est créé pour {{name}} et sa durée de validité repart de zéro. L'ancien lien cesse de fonctionner. Ce que votre client a déjà saisi est conservé.",
		confirm: "Créer un nouveau lien",
	},
	revoke_modal: {
		title: "Révoquer l'invitation ?",
		text: "{{name}} ne pourra plus accéder au portail avec son lien. Cette action est définitive.",
		text_submitted: "{{name}} ne pourra plus consulter le suivi de son dossier sur le portail. Le dossier déjà envoyé reste dans Wenimmo. Cette action est définitive.",
		confirm: "Révoquer l'invitation",
	},
};

export default translations;
